export interface ContractSelection {
  symbol: string;
  display_symbol?: string | null;
  sec_type?: string | null;
  con_id?: number | null;
  exchange?: string | null;
  currency?: string | null;
  local_symbol?: string | null;
  trading_class?: string | null;
  last_trade_date_or_contract_month?: string | null;
  multiplier?: string | null;
  long_name?: string | null;
  current_price?: number;
  current_price_stale?: boolean;
  current_price_delayed?: boolean;
  current_price_received_at?: string;
}

export const isQualifiedContract = (contract: ContractSelection | null): boolean => (
  Boolean(contract && (
    contract.sec_type === 'FUT'
    || contract.con_id
    || contract.last_trade_date_or_contract_month
    || contract.local_symbol
  ))
);

export const isFutureContract = (contract: ContractSelection | null): boolean => (
  String(contract?.sec_type || '').toUpperCase() === 'FUT'
);

export const getContractDisplaySymbol = (contract: ContractSelection): string => {
  if (contract.display_symbol) return contract.display_symbol;
  if (contract.local_symbol) return contract.local_symbol;
  if (contract.sec_type === 'FUT' && contract.last_trade_date_or_contract_month) {
    return `${contract.symbol} ${contract.last_trade_date_or_contract_month}`;
  }
  return contract.symbol;
};

export const filterPositionSuggestions = (
  positions: ContractSelection[],
  symbol: string,
  limit = 8,
): ContractSelection[] => {
  const normalizedSymbol = symbol.toUpperCase();
  return positions.filter((item) => {
    if (!normalizedSymbol) return true;
    return [item.symbol, item.local_symbol, item.trading_class]
      .filter(Boolean)
      .some((value) => String(value).toUpperCase().includes(normalizedSymbol));
  }).slice(0, limit);
};
